import { blue, orange, purple, teal, red, grey } from '@mui/material/colors';

const theme = {
  background: {
    // paper: '#fff',
    paper: '#ddd',
    // default: '#F8FBFD'
    default: '#999'
  },
  typography: {
    fontFamily: '"Roboto","Helvetica",sans-serif',
    fontSize: 12
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        root: {
          fontSize: 10
        }
      }
    }
  },
  palette: {
    primary: {
      main: blue[700],
      light: blue[400],
      dark: blue[900],
      contrastText: '#fff',
    },
    secondary: {
      main: orange[500],//'#E27425',
      light: orange[50],
      dark: orange[900],
      contrastText: '#fff',
    },
    neutral: {
      main: grey[700],
      light: grey[400],
      dark: grey[900],
      contrastText: '#fff',
    },
    white: {
      main: '#fff',
      contrastText: '#000'
    },
    offwhite: {
      main: grey[400],
      light: grey[50],
      contrastText: '#000'
    },
    paramchip: {
      main: '#ccc',
      contrastText: '#888',
    },
    success: {
      main: '#4caf50',
      contrastText: '#fff'
    },
    error: {
      main: '#f44336',
      contrastText: '#fff'
    },
    browser: {
      main: purple[800],
      light: purple[50],
      contrastText: '#fff'
    },
    sftp: {
      main: teal[800],
      light: teal[50],
      contrastText: '#fff'
    },
    sqlserver: {
      main: red[800],
      light: red[50],
      contrastText: '#fff'
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  }
};

export default theme;